"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATION = exports.STYLE_CONFIG = exports.ICON = void 0;
var TRANSLATION = {
  departs: 'Departs',
  bookingNo: 'Booking no.',
  flightNo: 'Flight no.',
  guest: 'Guest(s)',
  viewDetials: 'View Details'
};
exports.TRANSLATION = TRANSLATION;
var STYLE_CONFIG = {
  titleNormal: 'titleNormal',
  charcoalGrey: 'charcoalGrey',
  secondary: 'secondary',
  bold: 'bold',
  buttonType: 'button',
  buttonSize: '100px',
  default: 'default',
  padding: '4px',
  primary: 'primary',
  spinnerWidth: '20px',
  spinnerHeight: '20px',
  spinnerStrokeWidth: '4px'
};
exports.STYLE_CONFIG = STYLE_CONFIG;
var ICON = {
  FlightReverseIcon: 'FlightReverseIcon'
};
exports.ICON = ICON;